<template>
    <Modal>
        <template v-slot:header>
            <div class="col-10">
                <h3 class="sectionTitle">{{ title }}</h3>
            </div>
            <div class="col-2 d-flex justify-content-end">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-primary btn-sm" @click="selectNone()">{{ $t('common.actions.none') }}</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="selectAll()">{{ $t('common.actions.all') }}</button>    
                </div>
            </div>
        </template>

        <template v-slot:content>
            <slot name="content"></slot>
        </template>

        <template v-slot:activator="{ on }">
            <slot name="activator" :on="on"></slot>
        </template>
    </Modal>
</template>

<script>
import Toggle from "@/components/common/Toggle"
import ToggleGroup from "@/components/common/ToggleGroup"
import Modal from "@/components/common/Modal";

export default {
    name: 'ModalToggleGroup',
    components: {
        Toggle,
        Modal,
        ToggleGroup
    },
    props: {
        title: {
            type: String,
            required: true,
            default: "MISSING TITLE"
        }
    },
    methods: {
        selectNone: function() {
            // We use the events to communicate to the slot
            this.$root.$emit(`${this.$slots.content[0].tag}-selectNone`)
        },
        selectAll: function() {
            // We use the events to communicate to the slot
            this.$root.$emit(`${this.$slots.content[0].tag}-selectAll`)
        }
    },
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
    .btn {
        border-radius: $border-radius;
    }

    .propertiesRow {
        margin-bottom: 15px;
    }

    .sectionTitle {
        margin-bottom: 0px;
    }

    .btn-sm {
        line-height: 1.25em !important;
        max-height: 2.5em !important;
    }
</style>